import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const Onboarding: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsOnboarding" */ './components/Onboarding/index.ts'
			)
		).Onboarding,
});
